export const environment = {
	production: true,
	rootUrl: 'https://coreservices.venteksys.com/WebApi/V2.0/',
	commonApiUrl: 'https://coreservices.venteksys.com/WebApi/V2.0/api/common/',
	citationApiUrl: 'https://coreservices.venteksys.com/WebApi/V2.0/api/citationmgmt/',
	mcoApiScriptUrl: 'https://gateway.moneris.com/chktv2/js/chkt_v2.00.js',
	globalPayApiScriptUrl: 'https://js.globalpay.com/v1/globalpayments.js',
	appToken: 'cb90d8d8-e70b-44e6-a95c-887958231445',
	version: 'V2.0.0 (Production)',
};
